import moment = require("moment");
import {none, option, Option} from "ts-option";
import {ContactDetailsApiDto, SmsApiDto} from "../../api/model/rest";
import DateUtils from "../../utils/DateUtils";

export default class Sms {
	static fromJson(json: SmsApiDto): Sms {
		const contactDetails = json.individualContact ? option(ContactDetails.fromJson(json.individualContact)) : none;
		return new Sms(json.id, json.attached, json.content, moment(json.creationDateTime), contactDetails,
			option(json.leadId), json.phoneNumber, option(json.leadRefNumber));
	}

	constructor(public readonly id: string,
		public readonly attached: boolean,
		public readonly content: string,
		public readonly creationDateTime: moment.Moment,
		public readonly individualContact: Option<ContactDetails>,
		public readonly leadId: Option<string>,
		public readonly phoneNumber: string,
		public readonly leadReferenceNumber: Option<string>) {}

	/**
	 * Display date as formatted string.
	 * @returns {string}
	 */
	displayDate(): string {
		return this.creationDateTime.format(DateUtils.DATE_TIME_FORMAT)
	}
}

class ContactDetails {
	static fromJson(json: ContactDetailsApiDto): ContactDetails {
		return new ContactDetails(json.firstName, json.lastName);
	}

	constructor(readonly firstName: string,
		public readonly lastName: string) {}

	getName() {
		return `${this.firstName} ${this.lastName}`;
	}
}